module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("“ARE YOU")]), _vm._v(" sure you don’t want to come?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Erik had lost count of how many times his dad had asked. “Dad, I’m sure. You go and enjoy yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You know, you could enjoy yourself too, if you just let yourself go for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He had always been worried about him. Erik was pretty sure his dad thought he didn’t know how to have fun. Just because he didn’t have a lot of friends didn’t mean he didn’t get to enjoy himself. His idea of fun was just different from his father’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Come on, Dad, you know I would only drag you down. I don’t like crowded places, and you can’t even walk in Pamplona during the festival.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“How could you know that?” he asked, sounding surprised Erik actually knew something about his destination.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“You’ve been going there every year only for the last what? Twenty years? And you think I’ve never watched the running of the bulls trying to see you? I’m not that heartless, Dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I didn’t say you were. You’ve just never seemed interested in any of it, so I didn’t imagine you would have done that. But I’m glad to know you love your old man enough to care and watch just in case he gets trampled by a bull.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Erik would have been offended by that, had his dad not been smiling while he said it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Yes, yes, I do love you, which is why I want you to go alone and have fun without me tagging along. You deserve that.” And he was serious, as this was the only time of year his dad let himself forget the problems that troubled him at work during the rest of it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“Thank you, son. There’s no convincing you, I guess. I’m going to go pack. Remember you promised to drive me to the airport.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Erik couldn’t help but roll his eyes. “Yes, just like every year. Don’t worry, I’ll be ready. You know I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("“I know, I know,” he said, and with two pats to Erik’s shoulder, his dad left to pack his white and red clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Erik decided he should head to bed. The flight left at a ridiculously early hour, which meant he should go to sleep early if he wanted to be awake enough to drive. After his dad left, he’d have a week all to himself, and he was planning on taking advantage of it, writing nonstop. Not what his dad would consider fun, but putting words on paper was what made Erik happy, and he had a deadline coming up for his next book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34e75ce9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0006.vue
// module id = 72
// module chunks = 0